import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { columbusNeConfig } from "./data";

export default function ColumbusNePage() {
  return <CityPageTemplate config={columbusNeConfig} />;
}